import { Button, Form, Input, message } from 'antd';
import { useEffect, useState } from 'react';
import ImportServices from '@root/modules/Sellers/Import/services/import';
import moment from 'moment';
import { formatDateTime } from '@root/utils/helpers/formatDate';

export interface CardComment {
  title: string;
  date?: any;
  content?: string;
  btnText?: string;
  handleOpenEdit?: any;
  documId?: number;
  handlePage?: string;
  productId?: number;
  onSubmitted?: any;
}

const Comment = ({
  title,
  date,
  btnText,
  content,
  handleOpenEdit,
  handlePage,
  productId,
  onSubmitted
}: CardComment) => {
  const [selectedFile, setSelectedFile] = useState([] as any);
  const [fileIdArrNew, setfileIdArrNew] = useState([] as any);

  useEffect(() => {
    if (content) {
      content = '123';
    }
  }, [content]);

  const handleAddComment = async (values: any) => {
    const formData = new FormData();

    for (let i = 0; i < selectedFile.length; i++) {
      formData.append('files', selectedFile[i]);
    }
    try {
      const uploadData = await ImportServices.upLoad(formData);
      for (let i = 0; i < uploadData.data.paths.length; i++) {
        fileIdArrNew.push(uploadData.data.paths[i].fileId);
      }
      const body = {
        comment: values.comment,
        quotationId: productId,
        owner: 'Seller',
        documents: fileIdArrNew
      };
      const createCmt = await ImportServices.createCommentImport(body);
      if (createCmt.message === 'success') {
        message.success('Add comment success!');
        onSubmitted();
      }
    } catch (error) {}
  };

  return (
    <Form layout="vertical" style={{ width: '100%' }}>
      <div className="commentCard" style={{ marginBottom: '10px' }}>
        <div
          className="wrapTitle"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <p>{title}</p>
          <p style={{ color: '#A3A3A3' }}>
            {/* {moment(date)
              .utc(true ?? 9)
              .format('YYYY-MM-DD hh:mm:ss A')} */}
            {formatDateTime(date)}
          </p>
        </div>
        <div
          className="scrollImg"
          style={{
            height: '85px',
            // overflowY: 'scroll',
            // overflowX: 'scroll'
            wordBreak: 'break-all',
          }}
        >
          {handlePage ? <Input>{content}</Input> : <p>{content}</p>}
        </div>

        {btnText ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end'
            }}
          >
            <Button onClick={handleOpenEdit} type="primary">
              {btnText}
            </Button>
          </div>
        ) : null}
      </div>
    </Form>
  );
};

export default Comment;
